var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    _vm._b({ staticClass: "jade-stepper" }, "ul", _vm.$attrs, false),
    _vm._l(_vm.steps, function (step, index) {
      return _c(
        "li",
        {
          key: step.name,
          staticClass: "jade-stepper__item",
          attrs: { "data-testid": `item-${index}` },
        },
        [
          _c("jade-stepper-item", {
            attrs: {
              icon: step.icon,
              name: step.name,
              actived: step.actived,
              hasNext: index < _vm.steps.length - 1,
            },
          }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }